import { Pipe, PipeTransform } from '@angular/core';
import { PostItem } from '@apps/api-interfaces';
import { StorageService } from '@apps/ui';

@Pipe({
  name: 'perType'
})
export class AlertPerTypePipe implements PipeTransform {
  constructor(private storage: StorageService) {}

  public transform(
    items: PostItem[],
    types: string[],
    included: boolean
  ): any[] {
    if (!items || !items.length) {
      return items;
    }

    return (
      items
        // Zgody na cookies obsluguje baner CookieYes (index.html) - alert
        // 'cookies' z bazy nie jest juz renderowany.
        .filter(e => e.extra2 !== 'cookies')
        .filter(e => !this.isDisabled(e))
        .filter(e => types.includes(e.extra2) === included)
    );
  }

  private isDisabled(item: PostItem): boolean {
    if (item.disabled) {
      return true;
    }

    return !!this.storage.getItem(`alert_${item.slug}`);
  }
}
